import React from "react";
import { Tooltip } from "antd";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const FunctionalTestingLink = ({ id, text, action }) => {
  const { navigateToFunctionalTestingDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (action) {
      navigateToFunctionalTestingDetail(id);
    }
  };

  return (
    <Tooltip title={text}>
      <a
        onClick={handleClick}
        style={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          cursor: 'pointer'
        }}
      >
        {text}
      </a>
    </Tooltip>
  );
};

export default FunctionalTestingLink;

